__turbopack_context__.v({
  "productTable": "productTable-module-scss-module__6cbnuG__productTable",
});
